import React, { useEffect, useState } from 'react';

//*MUI
import Datagrid from '../../../Subcomponents/Datagrid';
import { Box, Divider } from '@mui/material';
//*Redux
import { useSelector } from 'react-redux';

//*files
import cssClasses from './AllotmentSoldDetails.module.css';
import {
  FetchTeamWiseUserFromServer,
  getUsersByTeams,
} from '../../../Services/Dashboard';
import _, { groupBy, uniqBy } from 'lodash';
import ViewAllotmentSoldDetails from '../../../Modals/ViewAllotmentSoldDetails/ViewAllotmentSoldDetails';
import { getProjectByTeamWise } from '../../../Services/AssignProject';
import { useNavigate } from 'react-router-dom';
import EmptyState from '../../../Assets/Images/Common/noProjectFound.svg';
import { dismissLoader, presentLoader } from '../../../Services/loader';
import MultiSelectDropDown from '../../../Subcomponents/MultiSelectDropDown/MultiSelectDropDown';
import CustomAutoComplete from '../../../Subcomponents/CustomAutoComplete';

function AllotmentSoldDetails() {
  let loggedInUser = {};
  const teamIds = JSON.parse(localStorage.getItem('teamIds'));

  loggedInUser = useSelector((state) => state.Auth.user);
  // console.log(loggedInUser);
  const navigate = useNavigate();
  const [drpDownSelectedVal, setDrpDownSelectedVal] = useState('');
  const [pageNumber, setPageNumber] = useState(0);
  const [AllotmentRows, setAllotmentRows] = useState([]);
  const [pageMaintain, setPageMaintain] = useState(0);
  const [pageSize, setPageSize] = useState(11);

  const [openAllotmentSoldDetails, setOpenAllotmentSoldDetails] =
    useState(false);
  const handleAllotmentSoldDetailsOpen = () =>
    setOpenAllotmentSoldDetails(true);
  const handleAllotmentSoldDetailsClose = () =>
    setOpenAllotmentSoldDetails(false);
  const [ViewAllotmentSoldData, setAllotmentSoldData] = useState(false);
  const [projectList, setProjectList] = useState([]);
  const [selectedProject, setSelectedProject] = useState([]);
  const [salesList, setSalesList] = useState([]);
  const [SalesUsers, setSalesUsers] = useState([]);
  const [salesName, setSalesName] = useState(null);
  const [NoAllotmentFound, setNoAllotmentFound] = useState(null);

  const [selectDates, setSelectDates] = useState([
    {
      label: 'StartDate',
      value: window.location.search.split('?')[2].split('=')[1],
    },
    {
      label: 'EndDate',
      value: window.location.search.split('?')[3].split('=')[1],
    },
  ]);

 

  useEffect(() => {
    const arr = [];
    const sales_arr = [];
    const fetchSales = async () => {
      const salesArr = await getUsersByTeams(teamIds);
   
      salesArr.data.forEach((s) => {
        sales_arr.push({
          name: s?.name,
          id: s?.userId,
        });
      });
      
    };
    const fetchProjects = async () => {
      const projectArr = await getProjectByTeamWise(teamIds); 
      uniqBy(projectArr.data, 'projectId.projectId').forEach((v) => {
        arr.push({
          name: v?.projectId?.projectName,
          id: v?.projectId?.projectId,
        });
      });
      const url_arr1 = window.location.search
      .split('?')[1]
      .split('=')[1]
      .split(',')
      .forEach((em) => {
        const url_val = arr.find((f) => f.name === decodeURIComponent(em));
        if (url_val !== undefined) {
          selectedProject.push(url_val);
        }
      });
      const sales_url = window.location.search.includes('salesPerson')
        ? decodeURIComponent(window.location.search.split('?')[4].split('=')[1])
        : 'All';
      const final_url = sales_arr.find(
        (f) => f.name === sales_url
      );
      setDrpDownSelectedVal(final_url === undefined ? 'All' : final_url.name);
      setSalesName(final_url === undefined ? '' : final_url.id);
      setSalesList(sales_arr);
     
      UsersFromServer(
        0,
        false,
        teamIds,
        selectedProject.map((m) => {
          return m.id;
        }),
        final_url ? final_url.id : null,
        selectDates
      );
      setProjectList(arr);
    };
    fetchProjects();
    fetchSales();
  }, []);

  
  const SoldDetailsColumns = [
    {
      field: 'salePerson',
      headerName: 'Sales Person',
      width: 250,
      renderCell: (params) => {
        return (
          <div style={{ wordBreak: 'break-word' }}>
            {params.row?.salePerson}
          </div>
        );
      },
    },
    {
      field: 'sold',
      headerName: 'Sold',
      width: 120,
      renderCell: (params) => {
        return (
          <div style={{ wordBreak: 'break-word' }}>{params.row?.sold}</div>
        );
      },
    },
    {
      field: 'area',
      headerName: 'Area',
      width: 150,
      renderCell: (params) => {
        return (
          <div style={{ wordBreak: 'break-word' }}>
            {params.row?.area ? `${params.row?.area} sq.ft` : ''}
          </div>
        );
      },
    },
    {
      field: 'cost',
      headerName: 'Value',
      width: 140,
      renderCell: (params) => {
        return (
          <div style={{ wordBreak: 'break-word' }}>
            {numDifferentiation(params.row?.cost)}
          </div>
        );
      },
    },
    {
      field: 'cp',
      headerName: 'CP',
      width: 120,
      renderCell: (params) => {
        return <div style={{ wordBreak: 'break-word' }}>{params.row?.cp}</div>;
      },
    },
    {
      field: 'direct',
      headerName: 'Direct',
      width: 125,
      renderCell: (params) => {
        return (
          <div style={{ wordBreak: 'break-word' }}>{params.row?.direct}</div>
        );
      },
    },
    {
      field: 'rl',
      headerName: 'R & L',
      width: 120,
      renderCell: (params) => {
        return <div style={{ wordBreak: 'break-word' }}>{params.row?.rl}</div>;
      },
    },
    {
      field: 'Details',
      headerName: '',
      width: 150,
      renderCell: (params) => {
        return (
          <div
            className={cssClasses.innerTitle}
            style={{
              cursor: 'pointer',
              textDecorationLine: 'underline',
              marginLeft: '2rem',
            }}
            onClick={() => {
              setAllotmentSoldData(params.row.value);
              handleAllotmentSoldDetailsOpen();
            }}
          >
            {params.row.value.length ? 'View' : ''}
          </div>
        );
      },
    },
  ];

  function numDifferentiation(val) {
    if (val >= 10000000) val = (val / 10000000).toFixed(2) + ' Cr';
    else if (val >= 100000) val = (val / 100000).toFixed(2) + ' Lac';
    else if (val >= 1000) val = (val / 1000).toFixed(2) + ' K';
    return val;
  }
  function UsersFromServer(
    pageNumber,
    merge,
    teamIds,
    projectId,
    userId,
    selectDates
  ) {
    presentLoader();
    FetchTeamWiseUserFromServer(
      pageNumber * pageSize,
      pageNumber * pageSize + pageSize - 1,
      teamIds,
      projectId,
      userId,
      selectDates
    )
      .then((UsersResp) => {
        const filteredData = UsersResp.data?.filter(
          (el) =>
            el.leadId !== null &&
            el.unitId !== null &&
            el.unitId?.projectId !== null &&
            el.leadId?.userId?.userId !== null
        );
        const groupByUserId = groupBy(filteredData, 'leadId.userId.userId');
        setSalesUsers(Object.values(groupByUserId));
        const MappedDetails = Object.values(groupByUserId)?.map(
          (val, index) => {
            let cost = 0;
            let area = 0;
            let sold = 0;
            let cp = 0;
            let direct = 0;
            let rl = 0;
            let costTotal = 0;
            let totalUnit = 0;
            val
              ?.filter(
                (e) =>
                  e.unitId?.inventoryStatusId?.status === 'Preselected' ||
                  e.unitId?.inventoryStatusId?.status === 'Payment Pending' ||
                  e.unitId?.inventoryStatusId?.status === 'Kyc Pending' ||
                  e.unitId?.inventoryStatusId.status === 'Kyc Done' ||
                  e.unitId.inventoryStatusId.status === 'Sold'
              )
              .map((i) => {
                cost += i?.unitCost?.bsp ? i?.unitCost?.bsp : 0;
                area += i?.unitId?.chargeableArea ?? 0;
                sold += 1;

                if (i?.leadId?.leadType === "CP") {
                  cp += 1;
                }
                if (i?.leadId?.leadType === 'Direct') {
                  direct += 1;
                }
                if (i?.leadId?.leadType === 'R&L') {
                  rl += 1;
                }
              });
            return {
              value: val?.filter(
                (e) =>
                  e.unitId?.inventoryStatusId?.status === 'Preselected' ||
                  e.unitId?.inventoryStatusId?.status === 'Payment Pending' ||
                  e.unitId?.inventoryStatusId?.status === 'Kyc Pending' ||
                  e.unitId?.inventoryStatusId?.status === 'Kyc Done' ||
                  e.unitId?.inventoryStatusId?.status === 'Sold'
              ),
              cost,
              area: area.toFixed(2),
              costTotal,
              total: val?.length,
              sold,
              cp,
              direct,
              rl,
              totalUnit,
              salePerson: val[0]?.leadId?.userId?.name,
              salesId: val[0]?.leadId?.userId?.userId,
              id: _.uniqueId(index),
            };
          }
        );

        let mappedDetailsChunkedArray = _.chunk(MappedDetails, 10);

        mappedDetailsChunkedArray.forEach((chunkElement) => {
          let _totalObject = {
            value: [],
            salePerson: 'subtotal',
            sold: chunkElement.reduce(
              (partialSum, a) => partialSum + a?.sold,
              0
            ),
            cost: chunkElement.reduce(
              (partialSum, a) => partialSum + a?.cost,
              0
            ),
            area: '',
            id: _.uniqueId('-'),
          };

          chunkElement.push(_totalObject);
        });
        const mappedDetailsFlattedArray = mappedDetailsChunkedArray.flat(1);
        const NodataFound = mappedDetailsFlattedArray.filter(
          (f) => f.salePerson === 'subtotal'
        );
        if (NodataFound.length > 0 && NodataFound[NodataFound.length - 1].sold > 0) {
          setNoAllotmentFound(true);
        } else {
          setNoAllotmentFound(false);
        }
        TotalBarDiv()
        setAllotmentRows(mappedDetailsFlattedArray);
        dismissLoader();
      })
      .catch((err) => {
        console.error('FetchAllUserFromServer', err);
        dismissLoader();
      });
  }


  function TotalBarDiv() {
    setTimeout(() => {
      if (
        document.querySelector(
          '#Allotment-data-grid .MuiDataGrid-virtualScrollerRenderZone'
        )?.childNodes?.length < 7
      ) {
        let _1stDom = document.querySelector(
          '#Allotment-data-grid .MuiDataGrid-virtualScrollerRenderZone > div:last-of-type'
        );
        let _2ndDom = document.querySelector(
          '#Allotment-data-grid .MuiDataGrid-virtualScrollerRenderZone'
        );

        if (_1stDom && _2ndDom) {
          _1stDom.style.position = 'fixed';
          _2ndDom.style.height = '100%';
        }
      } else {
        let _1stDom = document.querySelector(
          '#Allotment-data-grid .MuiDataGrid-virtualScrollerRenderZone > div:last-of-type'
        );
        let _2ndDom = document.querySelector(
          '#Allotment-data-grid .MuiDataGrid-virtualScrollerRenderZone'
        );

        if (_1stDom && _2ndDom) {
          _1stDom.style.position = 'sticky';
          _2ndDom.style.height = 'unset';
        }
      }
    }, 500);
  }

  function pageChanged(e) {
    setPageMaintain(e);
    if (pageNumber < e) {
      setPageNumber(e);
    }
    TotalBarDiv()
  }

  return (
    <>
      <Box className={cssClasses.Container}>
        <Box mb={1}>
          <Box className={cssClasses.SubContainer}>
            <Box className={cssClasses.DivContainer}>
              <Box className={cssClasses.HeaderTitle}>Allotment</Box>
            </Box>
          </Box>
        </Box>

        <Divider />

        <Box>
          <Box margin={'1rem 0'}>
            <Box className={cssClasses.SubContainer}>
              <Box
              >
                <div className={cssClasses.SubTitle} style={{marginBottom:"0.9rem"}}>Select Project:</div>
                <MultiSelectDropDown
                  list={projectList}
                  value={selectedProject}
                  handleChange={(e) => {
                    const value = e?.target?.value;
                    if (value !== '') {
                      if (value[value.length - 1] === 'all') {
                        setSelectedProject(
                          selectedProject.length === projectList.length
                            ? []
                            : projectList
                        );
                        UsersFromServer(
                          0,
                          false,
                          teamIds,
                          [],
                          drpDownSelectedVal?.value,
                          selectDates
                        );
                        return;
                      }
                      setSelectedProject(value);
                      UsersFromServer(
                        0,
                        false,
                        teamIds,
                        value.map((m) => {
                          return m.id;
                        }),
                        drpDownSelectedVal?.value,
                        selectDates
                      );
                      navigate(
                        window.location.pathname +
                          `?projectName=${value
                            .map((m) => {
                              return m.name;
                            })
                            .toString()}?startDate=${
                            selectDates[1]?.value !== ''
                              ? selectDates[1]?.value
                              : 0
                          }?endDate=${
                            selectDates[1]?.value !== ''
                              ? selectDates[1]?.value
                              : 0
                          }?salesPerson=${drpDownSelectedVal?.label ? drpDownSelectedVal?.label : "All"}`
                      );
                    }
                  }}
                  placeHolder={"Select Project"}
                  flag={true}
                />
              </Box>
              <Box width={'25rem'}>
              <div className={cssClasses.SubTitle}>Select Sales Person:</div>
                <CustomAutoComplete
                  value={drpDownSelectedVal}
                  NoOptionsText={'No Sales Users were found'}
                  InitialValue={setDrpDownSelectedVal}
                  OnInputChange={async (e, _value) => {
                    console.log("salesList" , salesList)
                    setDrpDownSelectedVal(_value);
                    const name_val = salesList.find((f) => f.name === _value);
                    if (name_val !== undefined || _value === "All") {
                      UsersFromServer(
                        0,
                        false,
                        teamIds,
                        selectedProject.map((m) => {
                          return m.id;
                        }),
                        _value === 'All' || name_val === undefined
                          ? null
                          : name_val?.id,
                        selectDates
                      );
                      navigate(
                        window.location.pathname +
                          `?projectName=${selectedProject
                            .map((m) => {
                              return m.name;
                            })
                            .toString()}?startDate=${
                            selectDates[1]?.value !== ''
                              ? selectDates[1]?.value
                              : 0
                          }?endDate=${
                            selectDates[1]?.value !== ''
                              ? selectDates[1]?.value
                              : 0
                          }?salesPerson=${_value}`
                      );
                    }
                  }}
                  list={
                    salesList
                      ? [
                          { label: 'All', value: 'All' },
                          ...salesList?.map((m , id) => ({
                            label: m?.name,
                            value: m?.id,
                          })),
                        ]
                      : []
                  }
                  renderOption={(props, SecondInputValue) => (
                    <Box
                      {...props}
                      key={SecondInputValue.id}
                    >
                        {SecondInputValue.label}
                     
                    </Box>
                  )}
                  disable={false}
                  placeholder='Select Sales Person'
                />
              </Box>
            </Box>
          </Box>
        </Box>
        {NoAllotmentFound === true && (
          <Box className={cssClasses.GridWrapper} id='Allotment-data-grid'>
            <Datagrid
              pageChanged={pageChanged}
              hideFooter={false}
              columns={SoldDetailsColumns}
              rows={AllotmentRows}
              rowsPerPageOptions={[11]}
              CancellationsAndRefunds={11}
              style={{
                '.MuiDataGrid-virtualScrollerRenderZone > div:last-of-type': {
                  backgroundColor: '#f9fafb',
                  fontWeight: '600',
                  color: '#707b9a',
                  fontSize: '1.8rem',
                  position: 'sticky',
                  bottom: '0',
                  borderTop: '1px solid lightGrey',
                  boxShadow: '1px 1px 1px 1px rgba(0,0,0,0.3)',
                },
              }}
            />
          </Box>
        )}
        {NoAllotmentFound === false && (
          <Box sx={{ height: '100%' }}>
            <Box className={cssClasses.noDataMsg}>
              <Box className={cssClasses.emptyIcon}>
                <img src={EmptyState} alt='No Wings' />
              </Box>
              <Box className={cssClasses.emptyTitle}>No Allotment found</Box>
            </Box>
          </Box>
        )}

        {openAllotmentSoldDetails && (
          <ViewAllotmentSoldDetails
            open={openAllotmentSoldDetails}
            handleClose={handleAllotmentSoldDetailsClose}
            data={ViewAllotmentSoldData}
          />
        )}
      </Box>
    </>
  );
}

export default AllotmentSoldDetails;
